// beforeinstallprompt приходить раз за завантаження, часто ще до того, як
// людина дійде до головної, — ловимо його одразу (див. usePwaInstall)
import { initPwaInstall } from '~/composables/usePwaInstall'

export default defineNuxtPlugin(() => {
  initPwaInstall()
})
